import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const RichTextEditorRibbonLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-richtexteditorribbon" */ "./RichTextEditorRibbon")).then((bundle)=>{
        return {
            default: bundle.RichTextEditorRibbon
        };
    });
export const LazyRichTextEditorRibbon = /*#__PURE__*/ lazy(RichTextEditorRibbonLazyLoader);
